import { InjectionToken } from '@angular/core';

export interface TimesheetModalData {
  year: number;
  month: number;
}

export const TIMESHEET_MODAL_DATA = new InjectionToken<TimesheetModalData>('TIMESHEET_MODAL_DATA');
